import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_GOOGLEAUTOSUGGESTIONS,
  GET_GOOGLEMAPPLACEDETAILS,
  GET_GOOGLEMAPDIRECTION,
  GET_GEOCODE,
  GET_RIDEDETAILSPOLYLINE
} from "resources/actionTypes";
import {
  autocompleteApi,
  directionApi,
  geocodeApi,
  placeApi,
  rideDetailsPolyLines,
} from "services/GoogleMapService";

function* fetchAutoComplete(action) {
  try {
    const payload = action.payload || {};
    const userAutoComplete = yield call(autocompleteApi, payload);
    yield put({
      type: GET_GOOGLEAUTOSUGGESTIONS.GET_GOOGLEAUTOSUGGESTIONS_SUCCESS,
      userAutoComplete: userAutoComplete,
    });
  } catch (e) {
    yield put({ type: GET_GOOGLEAUTOSUGGESTIONS.GET_GOOGLEAUTOSUGGESTIONS_FAILED, message: e.message });
  }
}
export function* autoCompleteSaga() {
  yield takeEvery(GET_GOOGLEAUTOSUGGESTIONS.GET_GOOGLEAUTOSUGGESTIONS_REQUESTED, fetchAutoComplete);
}

function* fetchPlaceDetails(action) {
  try {
    const payload = action.payload || {};
    const userPlaceDetails = yield call(placeApi, payload);
    if (payload.type === "pickUp") {
      yield put({
        type: GET_GOOGLEMAPPLACEDETAILS.GET_GOOGLEMAPPLACEDETAILSPICKUP_SUCCESS,
        userPlaceDetails: {
          pickup: userPlaceDetails,
        },
      });
    } else if (payload.type === "drop") {
      yield put({
        type: GET_GOOGLEMAPPLACEDETAILS.GET_GOOGLEMAPPLACEDETAILSDROP_SUCCESS,
        userPlaceDetails: {
          drop: userPlaceDetails,
        },
      });
    }else if (payload.type === "landmark") {
      yield put({
        type: GET_GOOGLEMAPPLACEDETAILS.GET_GOOGLEMAPPLACEDETAILSLANDMARK_SUCCESS,
        userPlaceDetails: {
          landmark: userPlaceDetails,
        },
      });
    }
  } catch (e) {
    yield put({
      type: GET_GOOGLEMAPPLACEDETAILS.GET_GOOGLEMAPPLACEDETAILS_FAILED,
      message: e.message,
    });
  }
}
export function* placeDetailsSaga() {
  yield takeEvery(GET_GOOGLEMAPPLACEDETAILS.GET_GOOGLEMAPPLACEDETAILS_REQUESTED, fetchPlaceDetails);
}

function* fetchDirection(action) {
  try {
    const payload = action.payload || {};
    const userDirection = yield call(directionApi, payload?.addressData);
    yield put({
      type: GET_GOOGLEMAPDIRECTION.GET_GOOGLEMAPDIRECTION_SUCCESS,
      userDirection: userDirection,
    });
  } catch (e) {
    yield put({ type: GET_GOOGLEMAPDIRECTION.GET_GOOGLEMAPDIRECTION_FAILED, message: e.message });
  }
}
export function* directionSaga() {
  yield takeEvery(GET_GOOGLEMAPDIRECTION.GET_GOOGLEMAPDIRECTION_REQUESTED, fetchDirection);
}

function* fetchGeocode(action) {
  try {
    const payload = action.payload || {};
    const userGeocode = yield call(geocodeApi, payload);
    yield put({
      type: GET_GEOCODE.GET_GEOCODE_SUCCESS,
      userGeocode: userGeocode,
    });
  } catch (e) {
    yield put({ type: GET_GEOCODE.GET_GEOCODE_FAILED, message: e.message });
  }
}
export function* geocodeSaga() {
  yield takeEvery(GET_GEOCODE.GET_GEOCODE_REQUESTED, fetchGeocode);
}

function* fetchRideDetailsPolyLines(action) {
  try {
    const payload = action.payload || {};
    const userRideDetails = yield call(rideDetailsPolyLines, payload);
    yield put({
      type: GET_RIDEDETAILSPOLYLINE.GET_RIDEDETAILSPOLYLINE_SUCCESS,
      userRideDetail: userRideDetails,
    });
  } catch (e) {
    yield put({ type: GET_RIDEDETAILSPOLYLINE.GET_RIDEDETAILSPOLYLINE_FAILED, message: e.message });
  }
}
export function* rideDetailsPolylineSaga() {
  yield takeEvery(GET_RIDEDETAILSPOLYLINE.GET_RIDEDETAILSPOLYLINE_REQUESTED, fetchRideDetailsPolyLines);
}
